import { mergeConfig } from 'Components/Worksheets/Core/Helpers/configHelpers';
import { getConfig as getMoistureContentConfig } from 'Components/Worksheets/MoistureContentWorksheet/BsEn/Config';
import getDerivedFromMeasurementsConfig from 'Components/Worksheets/ParticleDensityWorksheet/derivedFromMeasurementsConfig';
import getMeasuredUsingConfig from 'Components/Worksheets/ParticleDensityWorksheet/measuredUsingConfig';
import qestIds from 'Components/Worksheets/QestIds';
import getLabelConfig from './labelConfig';

const getConfig = (prefix: string) =>
  mergeConfig(
    getMoistureContentConfig(`${prefix}.Measurements.ConstantDryMass`),
    {
      [`${prefix}.Preparation.MinimumSampledMass`]: { uom: 'g', format: { nearest: 1 } },
      [`${prefix}.Measurements.InitialWaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.SoakingPeriod`]: { uom: 'h', format: { nearest: 0.1 } },
      [`${prefix}.Measurements.MinimumSoakingWaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.MaximumSoakingWaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.SampleWaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
      [`${prefix}.Measurements.WaterDensityAtTestTemperature`]: { uom: 'Mg/m³', format: { nearest: 0.0001 } },
      [`${prefix}.Measurements.ConstantDryMass.DryingTray.DryMassReadings.DryingTime`]: {
        uom: 'h',
        format: { nearest: 0.1 },
      },
      [`${prefix}.Results.ApparentParticleDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Results.OvenDriedParticleDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Results.SaturatedAndSurfaceDriedParticleDensity`]: { uom: 'Mg/m³', format: { nearest: 0.01 } },
      [`${prefix}.Results.WaterAbsorption`]: { format: { nearest: 0.1 } },
      [`${prefix}.Results.TestPortionMass`]: { uom: 'g', format: { nearest: 1 } },
      [`${prefix}.Results.TestWaterTemperature`]: { uom: '°C', format: { nearest: 1 } },
    },
    getMeasuredUsingConfig(prefix),
    getDerivedFromMeasurementsConfig(prefix),
    getLabelConfig(prefix),
    {
      [`${prefix}.Equipment.Balance`]: { defaultReadability: 1, defaultUom: 'g' },
      [`${prefix}.Equipment.MeasurementBalance`]: { defaultReadability: 1, defaultUom: 'g' },
      [`${prefix}.Measurements.ConstantDryMass.Equipment.DryMassBalance`]: {
        defaultReadability: 0.1,
        defaultUom: 'g',
      },
    }
  );

export { getConfig };

export default {
  [qestIds.particleDensity.BS_EN_1097_6_Clause_7.rev2022]: getConfig,
};
